(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smarthold-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!window.smartholdWhatsAppMeasurementBound) {
    window.smartholdWhatsAppMeasurementBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      let target;
      try { target = new URL(link.href, window.location.origin); } catch (_) { return; }
      if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(target.hostname)) return;
      const internal = !link.classList.contains('sh-wa__continue');
      const canonical = document.querySelector('link[rel="canonical"]');
      const parameters = {
        whatsapp_position: internal ? 'internal' : 'floating',
        page_location: canonical ? canonical.href : window.location.origin + window.location.pathname,
        page_title: document.title,
        link_url: target.origin + target.pathname,
        transport_type: 'beacon'
      };
      window.dataLayer = window.dataLayer || [];
      const gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      gtag('event', internal ? 'click_whatsapp_interno' : 'click_whatsapp', parameters);
    }, true);
  }
  if (window.smartholdWhatsAppWidgetBound) return;
  window.smartholdWhatsAppWidgetBound = true;
  const setOpen = (widget, open) => {
    const launcher = widget.querySelector('.sh-wa__launcher');
    widget.querySelector('.sh-wa__panel').hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    (open ? widget.querySelector('.sh-wa__close') : launcher).focus();
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.sh-wa__launcher, .sh-wa__close');
    if (!trigger) return;
    const widget = trigger.closest('.sh-wa');
    setOpen(widget, trigger.classList.contains('sh-wa__launcher') && widget.querySelector('.sh-wa__panel').hidden);
  });
  document.addEventListener('keydown', (event) => {
    const widget = document.getElementById('sh-wa');
    if (event.key === 'Escape' && widget && !widget.querySelector('.sh-wa__panel').hidden) setOpen(widget, false);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
